import RemoveProduct from './RemoveProduct'

export default RemoveProduct
